import {EventConstants} from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';

import type {ModelHubRoute} from './modelHubRoutes';

class ModelHubRouteStore extends Store {
  /**
   * The canonical route being viewed, or `null` when Model Hub was entered through the legacy
   * `/model-hub` URL (whose tab state lives in `?tab=` instead). `ModelHubScreen` renders the
   * legacy tabbed view for both today; BNCH-168599 branches on this to serve the redesigned pages
   * for canonical routes only.
   */
  currentRoute: ModelHubRoute | null = null;

  override resetState(): void {
    this.currentRoute = null;
  }

  getCurrentRoute(): ModelHubRoute | null {
    return this.currentRoute;
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.MODEL_HUB_SET_ROUTE: {
        this.currentRoute = action.route;
        this.emitChange();
        break;
      }
      case EventConstants.MODEL_HUB_CLEAR_ROUTE: {
        this.resetState();
        this.emitChange();
        break;
      }
      default: {
        break;
      }
    }
    return true;
  }
}

export default new ModelHubRouteStore(AppDispatcher);
